import { render, staticRenderFns } from "./MoveCdp.vue?vue&type=template&id=1fba3ce3&scoped=true&"
import script from "./MoveCdp.vue?vue&type=script&lang=js&"
export * from "./MoveCdp.vue?vue&type=script&lang=js&"
import style0 from "./MoveCdp.vue?vue&type=style&index=0&id=1fba3ce3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fba3ce3",
  null
  
)

export default component.exports